export default __webpack_public_path__ + "static/media/logo-whiteOLD.df161ba1.svg";